const config = {
  mbAudioItemData: [
    {
      id: 'a01',
      src: 'games/page037_game1/audio/56_canary.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page037_game1/img/audioOn.png', iconOff: 'games/page037_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 20,
        x: 194,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: 'games/page037_game1/audio/54_hamster.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page037_game1/img/audioOn.png', iconOff: 'games/page037_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 20,
        x: 194,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: 'games/page037_game1/audio/55_parrot.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page037_game1/img/audioOn.png', iconOff: 'games/page037_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 20,
        x: 194,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
  ],
  blockCheck: true,
  mainImage: {
    src: 'games/page037_game1/img/bcg.webp',
  },

  multiconnect: false,
  globalItemsConfig: {
    hookPoint: {
      rad: 0,
    },
  },
  dontCheckIncorrectLines: false,
  dontAcceptIncorrectLines: true,

  linesStyle: {
    colors: {
      bad: 'red',
      good: 'green',
      neutral: '#4cb9fa',
    },
    size: 5,
  },
  rules: [
    { connectId: 1, connectedWith: 4 },
    { connectId: 2, connectedWith: 5 },
    { connectId: 3, connectedWith: 6 },
  ],

  autoCheck: true,
  numberOfGoodLines: 3,
  sounds: [
    { src: 'games/page037_game1/audio/false.mp3', id: 'endConnect' },
    { src: 'games/page037_game1/audio/click.mp3', id: 'startConnect' },
    { src: 'games/page037_game1/audio/56_canary.mp3', id: 'a' },
    { src: 'games/page037_game1/audio/54_hamster.mp3', id: 'b' },
    { src: 'games/page037_game1/audio/55_parrot.mp3', id: 'c' },
  ],
  groups: [
    {
      name: 'left',
      items: [
        {
          audioId: 'a',
          connectId: 1,
          image: { src: 'games/page037_game1/img/0-1.webp' },
          imageStyle: { position: 'absolute', width: '305px', height: '286px' },
          pos: {
            x: 200,
            y: 120,
            width: 305,
            height: 286,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 195, y: 143 }],
          // namedHooks: ['right'],
        },
        {
          audioId: 'b',
          connectId: 2,
          image: { src: 'games/page037_game1/img/1-1.webp' },
          imageStyle: { position: 'absolute', width: '305px', height: '286px' },
          pos: {
            x: 200,
            y: 120 + 300,
            width: 305,
            height: 286,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 195, y: 143 }],
        },
        {
          audioId: 'c',
          connectId: 3,
          image: { src: 'games/page037_game1/img/2-1.webp' },
          imageStyle: { position: 'absolute', width: '305px', height: '286px' },
          pos: {
            x: 200,
            y: 120 + 300 * 2,
            width: 305,
            height: 286,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 195, y: 143 }],
        },
      ],
    },
    {
      name: 'right',
      disableShuffle: false,
      items: [
        {
          audio: 'a01',
          connectId: 4,
          image: { src: 'games/page037_game1/img/0-0.webp' },
          imageStyle: { position: 'absolute', width: '305px', height: '286px' },
          pos: {
            x: 1464,
            y: 120 + 300 * 0,
            width: 305,
            height: 286,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          namedHooks: ['left'],
        },
        {
          audio: 'a02',
          connectId: 5,
          image: { src: 'games/page037_game1/img/1-0.webp' },
          imageStyle: { position: 'absolute', width: '305px', height: '286px' },
          pos: {
            x: 1464,
            y: 120 + 300 * 1,
            width: 305,
            height: 286,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          namedHooks: ['left'],
        },
        {
          audio: 'a03',
          connectId: 6,
          image: { src: 'games/page037_game1/img/2-0.webp' },
          imageStyle: { position: 'absolute', width: '305px', height: '286px' },
          pos: {
            x: 1464,
            y: 120 + 300 * 2,
            width: 305,
            height: 286,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          namedHooks: ['left'],
        },
      ],
    },
  ],
};
export default config;
